import React, { createContext, useContext, useReducer, Dispatch } from 'react'
import {
  CaseReportRespType,
  CaseReportId,
  PostCaseReportRespType,
  UserProfileDataType,
  CaseTypeType,
} from '../models'
import { TreatmentExpensesInitialValues } from '../helpers'

type ClaimantStateType = {
  pdf: any
}

export const isDEV = process.env.NODE_ENV === 'development'

export const initialCost = [
  {
    orderNum: TreatmentExpensesInitialValues.orderNum,
    expenseType: TreatmentExpensesInitialValues.expenseType,
    costDate: TreatmentExpensesInitialValues.costDate,
    amount: TreatmentExpensesInitialValues.amount,
    currency: TreatmentExpensesInitialValues.currency,
    paidDirectly: TreatmentExpensesInitialValues.paidDirectly,
    attachments: TreatmentExpensesInitialValues.attachments,
  },
]

const initialState: CaseReportStateType = {
  caseType: null,
  caseReportId: null,
  // TODO token ;)
  loadedCaseReportResp: undefined,
  webUserId: null,
  webUser: null,
  data: {
    pdf: null,
  },
  error: '',
  controlChange: true,
}

type CaseReportStateType = {
  caseType: CaseTypeType | null
  caseReportId: CaseReportId | null
  // TODO token: string | null
  loadedCaseReportResp: CaseReportRespType | undefined
  webUserId: string | null
  webUser: UserProfileDataType | null
  // Dalsi zrusit ;)
  data: ClaimantStateType
  error: string
  controlChange: boolean
}

type CaseReportContextType = {
  state: CaseReportStateType
  dispatch: Dispatch<any>
}

const claimantReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'initial_state':
      return {
        ...initialState,
      }

    // 'CaseReportCreated' <- CaseReport was created with data in 'payload.caseReportPostResp'
    case 'CaseReportCreated': {
      const postCaseReportResp: PostCaseReportRespType =
        action.payload.postCaseReportResp
      return {
        ...state,
        caseReportId: postCaseReportResp.id,
        error: '',
      }
    }

    // 'load_case_data' <- CaseReport was loaded with data in 'payload.loadedCaseReportResp'
    case 'load_case_data':
      return {
        ...state,
        loadedCaseReportResp: action.payload.loadedCaseReportResp,
        error: '',
      }

    case 'update_caseReportParams':
      return {
        ...state,
        loadedCaseReportResp: action.payload.data,
        error: '',
      }

    case 'pdf': {
      return {
        ...state,
        data: {
          ...state.data,
          pdf: action.payload.pdf,
        },
      }
    }

    case 'WebUserLoaded': {
      // WebUserLoaded
      if (action.payload.webUser == null) {
        throw new Error("Parameter 'webUser' required for 'WebUserLoaded'")
      }

      const webUser: UserProfileDataType = action.payload.webUser
      const webUserId: string = action.payload.webUserId
      return {
        ...state,
        webUserId: webUserId,
        webUser: webUser,
      }
    }
    case 'WebUserId_received':
      return { ...state, webUserId: action.payload.webUserId }

    case 'error':
      return { ...state, error: action.payload.error }
    case 'control_change':
      return { ...state, controlChange: action.payload.controlChange }
    case 'case_type':
      return { ...state, caseType: action.payload.caseType }
    default:
      return state
  }
}

export const ClaimantContext = createContext<CaseReportContextType>({
  state: initialState,
  dispatch: () => null,
})

export interface ClaimantContextProps {
  children: React.ReactElement
}

export default ({ children }: ClaimantContextProps) => {
  //@ts-ignore
  const [state, dispatch] = useReducer(claimantReducer, initialState)
  return (
    <ClaimantContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </ClaimantContext.Provider>
  )
}

export const useClaimant = () => useContext(ClaimantContext)
